import { adminNavigationLinks } from './admin.navigation-links';
import { baseNavigationLinks } from './base.navigation-links';
import { NavigationLink } from './navigation-link.type';
import { teacherNavigationLinks } from './teacher.navigation-links';

export const navigationLinks = new Map<string, NavigationLink[]>([
  ['base', baseNavigationLinks],
  ['admin', adminNavigationLinks],
  ['teacher', teacherNavigationLinks],
]);
